import { Routes } from '@angular/router';
import { PAGE } from './routes';
import { initialisedGuard } from './core/guards/initialised.guard';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./features/loading/loading.page').then((m) => m.LoadingPage),
  },
  {
    path: `${PAGE.GAME}/:gameId`,
    canActivate: [initialisedGuard],
    loadComponent: () => import('./features/game/game/game.page').then((m) => m.GamePage),
  },
  {
    path: PAGE.RESULTS,
    canActivate: [initialisedGuard],
    loadComponent: () => import('./features/results/results.page').then((m) => m.ResultsPage),
  },
  {
    path: PAGE.CHOOSE_LEADERBOARDS,
    canActivate: [initialisedGuard],
    loadComponent: () =>
      import('./features/leaderboards/choose-leaderboards.page').then(
        (m) => m.ChooseLeaderboardsPage,
      ),
  },
  {
    path: `${PAGE.SELECT_RULES}/:gameId`,
    canActivate: [initialisedGuard],
    loadComponent: () =>
      import('./features/rules/select-rules.page').then((m) => m.SelectRulesPage),
  },
  { path: '**', redirectTo: PAGE.RESULTS },
];
